import React from "react";
import classes from './ItemLanguage.module.scss'

const ItemLanguage = (props: any) => {
    const closeModal = () => {
        switch(props.id) {
            case 1:
                props.setCurrentLanguage('EN')
                props.onChangeLanguage('EN')
                break;

            case 2:
                props.setCurrentLanguage('PL')
                props.onChangeLanguage('PL')
                break;
            
            case 3:
                props.setCurrentLanguage('RU')
                props.onChangeLanguage('RU')
                break;

            default:
                props.setCurrentLanguage('EN')
                props.onChangeLanguage('EN')
                break;
        }
    }
 
    return(
        <div className={classes.block} onClick={closeModal}>
            <div className={classes.block__language}>
                <img src={props.src} alt={props.alt} className={classes.block__language_flag}/>
                <p className={classes.block__language_text}>{props.text}</p>
            </div>
            <img src={require('../../img/checkMark.png')} alt="Check mark" className={props.currentLanguage === props.value ? `${classes.block_checkMark}` : `${classes.block_hideCheckMark}`}/>
        </div>
    )
}

export default ItemLanguage